var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoseTip = function SvgNoseTip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 35,
    viewBox: "0 0 0.64 0.78",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.17.06S.2.19.2.22C.2.39.21.28.09.35.05.37.04.44.08.47c.02.01.09.06.16.1M.5.56C.54.51.58.45.58.39.58.31.47.31.42.31.41.27.41.09.39.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.35.57C.24.65.4.76.43.64.44.6.41.59.39.58.38.57.36.57.35.57zM.23.65C.22.6.24.54.3.5.33.48.35.48.38.48.4.48.42.49.43.5h.01C.5.53.55.56.52.66.5.74.45.77.39.78.36.78.32.77.29.75a.11.11 0 0 1-.06-.1z",
    fill: "#000"
  })));
};

export default SvgNoseTip;